import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import SectionHeader from '../components/common/SectionHeader';
import PodcastCard from '../components/common/PodcastCard';

const episodes = [
  { series: 'Generazione Politica', title: 'Ep. 12 — Cosa significa fare politica a 20 anni oggi', meta: '18 Mar 2026 · 32 min', image: 'https://images.unsplash.com/photo-1529156069898-49953eb1b5ae?q=80&w=400&auto=format&fit=crop' },
  { series: 'Generazione Politica', title: 'Ep. 11 — La sfida delle periferie: voci dal territorio', meta: '11 Mar 2026 · 28 min', image: 'https://images.unsplash.com/photo-1449156003053-c2d82cee5025?q=80&w=400&auto=format&fit=crop' },
  { series: 'Generazione Politica', title: 'Ep. 10 — Ambiente e giustizia climatica: che fare?', meta: '4 Mar 2026 · 38 min', image: 'https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?q=80&w=400&auto=format&fit=crop' },
  { series: 'Generazione Politica', title: 'Ep. 9 — Diritto allo studio: stato dell\'arte', meta: '25 Feb 2026 · 35 min', image: 'https://images.unsplash.com/photo-1523050853051-f7500248a13f?q=80&w=400&auto=format&fit=crop' },
  { series: 'Generazione Politica', title: 'Ep. 8 — Le storie degli eletti: chi sono e cosa fanno', meta: '18 Feb 2026 · 42 min', image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=400&auto=format&fit=crop' },
];

const PodcastPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Podcast' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Media" title="Podcast" subtitle='"Generazione Politica" — Il podcast dei Giovani Democratici.' />
      <section className="section section--sm"><div className="container">
        {/* Banner */}
        <div className="card mb-10 overflow-hidden" style={{ background: '#111', color: '#fff', borderRadius: 'var(--radius-xl)', display: 'flex', gap: 'var(--space-8)', alignItems: 'center', flexWrap: 'wrap', position: 'relative' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
            <img src="https://images.unsplash.com/photo-1590602847861-f357a9332bbc?q=80&w=1200&auto=format&fit=crop" alt="Podcast Background" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.3 }} />
          </div>
          <div style={{ width: 200, height: 200, background: 'rgba(255,255,255,0.1)', borderRadius: 'var(--radius-xl)', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '4rem', position: 'relative', zIndex: 1, margin: 'var(--space-8)' }}>🎙️</div>
          <div style={{ flex: 1, minWidth: 250, position: 'relative', zIndex: 1, padding: 'var(--space-8) var(--space-8) var(--space-8) 0' }}>
            <div className="text-overline mb-2" style={{ color: 'rgba(255,255,255,0.7)' }}>Il nostro Podcast</div>
            <h2 style={{ color: '#fff', fontFamily: 'var(--font-display)', fontSize: 'var(--text-h2)', marginBottom: 'var(--space-3)' }}>Generazione Politica</h2>
            <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: 'var(--space-4)' }}>Ogni settimana, storie di politica, territorio e partecipazione dalla voce dei Giovani Democratici.</p>
            <div className="flex gap-3 flex-wrap"><button className="btn btn--white btn--sm">Spotify</button><button className="btn btn--white btn--sm">Apple Podcasts</button><button className="btn" style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' }}>RSS</button></div>
          </div>
        </div>

        {/* Audio player */}
        <SectionHeader overline="Ultimo Episodio" className="mb-6" />
        <div className="audio-player mb-10">
          <div className="audio-player__cover">
            <img src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?q=80&w=400&auto=format&fit=crop" alt="Episode Cover" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div className="audio-player__info">
            <div className="audio-player__series">Generazione Politica — Ep. 12</div>
            <div className="audio-player__title">Cosa significa fare politica a 20 anni oggi</div>
            <div className="audio-player__meta">18 Mar 2026 · 32 min</div>
          </div>
          <div className="audio-player__controls">
            <button className="audio-player__play" aria-label="Riproduci">▶</button>
            <div className="audio-player__timeline"><div className="audio-player__progress" style={{ width: '0%' }}></div></div>
            <span className="audio-player__time">00:00 / 32:15</span>
          </div>
        </div>

        {/* All episodes */}
        <SectionHeader overline="Tutti gli episodi" className="mb-6" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
          {episodes.map((ep) => <PodcastCard key={ep.title} {...ep} />)}
        </div>
      </div></section>
    </Layout>
  );
};

export default PodcastPage;
